<template>
  <div>
    <h2 class="title is-2">
      Collections
    </h2>

    <b-notification
      v-if="loaded && collections.length === 0"
      :closable="false"
    >
      You don't have any collections.
    </b-notification>

    <div
      v-if="loaded && collections.length > 0"
      class="columns is-desktop is-multiline"
    >
      <collection-list-item
        v-for="collection in collections"
        :key="collection.pk"
        :collection="collection"
      />
    </div>

    <div
      v-if="!loaded"
      class="columns"
    >
      <div class="column is-12 has-text-centered">
        <br>
        <span
          class="loader xl"
          style="display: inline-block; width: 3em; height: 3em;"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CollectionListItem from '@/components/CollectionListItem.vue'

export default {
  name: 'CollectionList',

  components: {
    CollectionListItem
  },

  data () {
    return {
      loaded: false
    }
  },

  computed: {
    collections: function () {
      return this.$store.getters['collections/collections']
    },
    user: function () {
      return this.$store.getters['user/currentUser']
    },
    fullName: function () {
      return this.$store.getters['user/fullName']
    }
  },

  created () {
    this.$store.dispatch('collections/fetchCollections')
      .then(() => {
        this.loaded = true
      })
  },

  metaInfo: {
    title: 'Collections'
  }
}
</script>

<style>
</style>
